/**
 * Design tokens, mirrored from src/scss/_tokens.scss for the MUI theme and
 * any TypeScript that needs a token value. Edit both files together;
 * src/__tests__/tokens.test.ts fails when they disagree.
 */
export const nucTokens = {
  ink: "#102d35",
  muted: "#52666b",
  green: "#258552",
  greenBright: "#47c972",
  cyan: "#2395b7",
  cyanLight: "#66c9ea",
  canvas: "#f3f6f4",
  surface: "#f8faf9",
  line: "#d9e2de",
  white: "#ffffff",
  fontBody: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontHeading: '"Poppins", -apple-system, BlinkMacSystemFont, sans-serif',
  fontMono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  radiusControl: "8px",
  radiusCard: "12px",
  radiusPill: "999px",
  focusRing: "0 0 0 3px rgba(35, 149, 183, 0.18)",
  headerHeight: "56px",
  headerHeightCompact: "52px",
} as const;

export type NucTokens = typeof nucTokens;
